module.exports = __webpack_public_path__ + "img/pending_zone_selected.9a85e70f.svg";